import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import WhatWeDo from './pages/WhatWeDo';
import Contact from './pages/Contact';
import Pilot from './pages/Pilot';
import pilotSlides from './pages/PilotSlides';
import pilotPresSlides from './pages/PilotPresSlides';
import './App.css';

// ScrollToTop component to handle scrolling to top on route changes
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Public marketing layout: header + footer chrome around the page content
function MarketingLayout() {
  return (
    <div className="App">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Public, navigable pages */}
        <Route element={<MarketingLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/what-we-do" element={<WhatWeDo />} />
          <Route path="/contact" element={<Contact />} />
        </Route>

        {/* Unlisted, password-protected investor presentations.
            Intentionally NOT linked from the Header, Footer, or sitemap.
            /pilot      - full self-read investor deck
            /pilotpres  - punchier pitch cut, technical detail parked at the back */}
        <Route path="/pilot" element={<Pilot slides={pilotSlides} docTitle="Sequester CCS - Pilot Project" />} />
        <Route path="/pilotpres" element={<Pilot slides={pilotPresSlides} docTitle="Sequester CCS - Pilot Pitch" />} />
      </Routes>
    </Router>
  );
}

export default App; 